import EyeOffIcon from '@heroicons/react/outline/EyeOffIcon'
import LockClosedIcon from '@heroicons/react/outline/LockClosedIcon'

import {
  CustomFieldPrivacyOptions,
  CustomFieldSchema,
} from '@tribeplatform/gql-client/types'
import { Tooltip } from '@tribeplatform/react-ui-kit/Tooltip'

export const FieldPrivacyBadges = ({
  field,
}: {
  field: Partial<CustomFieldSchema>
}) => {
  const badges = []
  if (field?.readPrivacy?.allow) {
    if (field?.readPrivacy?.allow.indexOf(CustomFieldPrivacyOptions.OWN) === -1)
      badges.push(
        <Tooltip>
          <Tooltip.Trigger>
            <EyeOffIcon className="text-basicSurface-400 w-4 h-4" />
          </Tooltip.Trigger>
          <Tooltip.Panel>
            This field is only visible to community admins and moderators.
          </Tooltip.Panel>
        </Tooltip>,
      )
    else if (
      field?.readPrivacy?.allow.indexOf(CustomFieldPrivacyOptions.ADMIN) === -1
    )
      badges.push(
        <Tooltip>
          <Tooltip.Trigger>
            <EyeOffIcon className="text-basicSurface-400 w-4 h-4" />
          </Tooltip.Trigger>
          <Tooltip.Panel>
            This field is only visible to the owner, community admins, and
            moderators.
          </Tooltip.Panel>
        </Tooltip>,
      )
  }

  if (field?.writePrivacy?.allow) {
    if (
      field?.writePrivacy?.allow.indexOf(CustomFieldPrivacyOptions.OWN) === -1
    )
      badges.push(
        <Tooltip>
          <Tooltip.Trigger>
            <LockClosedIcon className="text-basicSurface-400 w-4 h-4" />
          </Tooltip.Trigger>
          <Tooltip.Panel>Only admins can update this field.</Tooltip.Panel>
        </Tooltip>,
      )
  }

  return <>{badges}</>
}
